import {Module} from '@fantasmagames/slot/src/common/Module';
import {StopAutoplayButtonView} from '@fantasmagames/slot/src/modules/keypad/stopautoplaybutton/StopAutoplayButtonView';
import {StopAutoplayButtonEvents} from '@fantasmagames/slot/src/modules/keypad/stopautoplaybutton/StopAutoplayButtonEvents';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {AutoplayMenuEvents} from '@fantasmagames/slot/src/modules/popupmenus/autoplaymenu/AutoplayMenuEvents';
import {AutoplayHandlerEvents} from '@fantasmagames/slot/src/modules/autoplay/AutoplayHandlerEvents';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';
import {ScreenEvents} from '@fantasmagames/core/src/screen/ScreenEvents';

export class StopAutoplayButtonModule extends Module<StopAutoplayButtonView> {
	protected _isAutoplayActive: boolean = false;

	protected enterFirstState(): void {
	}

	protected setupStates(): void {
	}

	protected setupViews(): void {
		if (this.system.shouldUseMultipleViews()) {
			this.setView(Views.STOP_AUTOPLAY_BUTTON_VIEW_MOBILE);
		} else {
			this.setView(Views.STOP_AUTOPLAY_BUTTON_VIEW);
		}
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.onView(StopAutoplayButtonView.STOP_AUTOPLAY_BUTTON_CLICKED, this.onStopAutoplayClicked);

		this.on(AutoplayMenuEvents.ACCEPTED, this.onStartAutoplay);
		this.on(AutoplayHandlerEvents.AUTOPLAY_ROUNDS_FINISHED, this.onAutoplayRoundsFinished);
		this.on(AutoplayHandlerEvents.START_AUTOPLAY_SPIN, this.onStartAutoPlaySpin);

		/** According to ReCode integration we need to stop autoplay on bonus games. */
		this.on(FlowModuleEvents.BONUS_GAME_START, this.onBonusGameStart);
		// this.on(FlowModuleEvents.BONUS_GAME_END, this.onBonusGameEnd);
		// this.on(BonusGameEvents.BONUS_OUTRO_FINISHED, this.onBonusGameEnd);

		this.on(SpinButtonEvents.SPIN_PRESSED_NOT_ENOUGH_MONEY, this.onNotEnoughMoney);

		this.on(ScreenEvents.BECAME_VISIBLE, this.onBecameVisible);
		this.on(ScreenEvents.BECAME_INVISIBLE, this.onBecameInvisible);
	}

	protected onBecameVisible(): void {

	}

	protected onBecameInvisible(): void {
		this.stopAutoplay();
	}

	protected onNotEnoughMoney(): void {
		this.stopAutoplay();
	}

	protected onStopAutoplayClicked(): void {
		this.stopAutoplay();
	}

	protected onAutoplayRoundsFinished(): void {
		this.stopAutoplay();
	}

	protected onBonusGameStart(): void {
		this.stopAutoplay();
	}

	protected onStartAutoPlaySpin(eventId: string, currentSpins: number, totalSpins: number): void {
		this.view.updateSpinsLeft(currentSpins, totalSpins);
	}

	// protected onBonusGameEnd(): void {
	// 	this.view.show();
	// }

	// protected onBonusGameStart(): void {
	// 	this.view.hide();
	// }

	protected stopAutoplay(): void {
		if (this._isAutoplayActive) {
			this.eventManager.emit(StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED);
			this.view.uninitAutoplay();
			this._isAutoplayActive = false;
		}
	}

	protected onStartAutoplay(): void {
		if (!this._isAutoplayActive) {
			this._isAutoplayActive = true;
			this.view.initAutoplay();
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/keypad/stopautoplaybutton/StopAutoplayButtonModule.ts